<template>
	<div class>
		<page-title :title="$t('documentsRelation.title')" :showTitle="false"></page-title>
		<div class="card col-12 mx-auto mt-2 px-0">
			<div class="card-header bg-primary text-white">
				<div class="card-title h5 m-0">{{ $t('documentsRelation.title') }}</div>
			</div>

			<div class="card-header" v-if="showSettingsBtn">
				<button type="button" class="btn btn-primary btn-lg" v-if="showNewButton" @click="goToCreate">{{$t('buttons.create.btnText')}}</button>

				<button
					type="button"
					class="btn btn-primary btn-lg"
					v-if="showExportTemplateButton"
					@click="goToExportTemplate"
				>{{$t('buttons.exportTemplate.btnText')}}</button>
				<label>
					<input type="checkbox" id="exportWithData" class="checkbox" v-if="showExportTemplateButton" />
					<span v-if="showExportTemplateButton">{{$t('checkboxes.exportWithData.cbText')}}</span>
				</label>

				<form enctype="multipart/form-data" method="post" id="importForm" class="inlineForm">
					<div class="inlineForm">
						<button
							type="button"
							class="btn btn-primary btn-lg"
							v-if="showImportFromExcelButton"
							@click="selectImportFiles"
						>{{$t('buttons.importFromExcel.btnText')}}</button>
						<input type="file" id="importFile" class="selectFile" @change="goToImportFromExcel" />
					</div>
				</form>

				<i
					class="fas fa-cogs pointer fa-2x float-right text-success"
					v-if="showSettingsBtn"
					@click.stop="changeGridSettings"
					data-toggle="tooltip"
					:title="settingsTooltipText"
				></i>

				<grid-user-settings :schemaModelFields="schemaModelFields" :componentName="componentName" v-if="showUserSettingsForm" @change="gridSettingsChanged"></grid-user-settings>
			</div>

			<div class="btn-toolbar justify-content-between mt-3" role="toolbar">
				<div class="form-inline col-lg-6 col-md-12"></div>

				<div class="input-group col-lg-6 col-md-12">
					<input
						v-model="searchQuery"
						v-on:keyup.enter.stop="massSearch"
						v-on:keyup.esc.stop="clearFilters"
						type="text"
						class="form-control"
						aria-label="Mass search input"
						aria-describedby="massSearch"
					/>
					<button class="btn btn-secondary" @click.stop="massSearch">
						<i class="fas fa-search"></i>
						{{ $t('buttons.search.btnText') }}
					</button>
					<button class="btn btn-secondary" @click.stop="clearFilters">
						<i class="fas fa-times"></i>
						{{ $t('buttons.clearFilters.btnText') }}
					</button>
				</div>
			</div>

			<div class="loader" v-show="loading"></div>
			<div class="card-body" v-show="!loading">
				<kendo-datasource
					ref="datasource1"
					:transport="transportSettings"
					:schema-model-id="'id'"
					:schema-model-fields="schemaModelFields"
					:schema-total="'total'"
					:schema-data="'data'"
					:page-size="defaultGridRows"
					:server-paging="true"
					:server-sorting="true"
					:server-filtering="true"
					:error="dataSourceError"
				></kendo-datasource>

				<kendo-grid
					ref="grid"
					id="grid"
					:height="600"
					:data-source-ref="'datasource1'"
					:editable="gridOptions.editable"
					:filterable="gridOptions.filterable"
					:pageable="gridOptions.pageable"
					:reorderable="gridOptions.reorderable"
					:resizable="gridOptions.resizable"
					:groupable="gridOptions.groupable"
					:allow-copy="gridOptions.allowCopy"
					:column-menu="gridOptions.columnMenu"
					:sortable-mode="gridOptions.sortable.mode"
					:sortable-allow-unsort="gridOptions.sortable.allowUnsort"
					:sortable-show-indexes="gridOptions.sortable.showIndexes"
					:selectable="gridOptions.selectable"
					:scrollable="gridOptions.scrollable"
					:dataBound="dataBound"
				>
					<!-- <kendo-grid-column :field="'id'" :title="$t('documentsRelation.id')"></kendo-grid-column> -->
					<kendo-grid-column :field="'name'" :title="$t('documentsRelation.name')"></kendo-grid-column>
					<!-- <kendo-grid-column :field="'extension'" :title="$t('documentsRelation.documentExtension')"></kendo-grid-column> -->
					<kendo-grid-column :field="'createdOn'" :title="$t('documentsRelation.createdOn')" :format="'{0:dd.MM.yyyy H:mm}'"></kendo-grid-column>
					<kendo-grid-column :field="'createdBy'" :title="$t('documentsRelation.createdBy')"></kendo-grid-column>
					<kendo-grid-column :field="'type'" :title="$t('documentsRelation.type')"></kendo-grid-column>
					<kendo-grid-column :field="'docTypeCode'" title="DocTypeCode"></kendo-grid-column>
					<kendo-grid-column :field="'eventName'" :title="$t('documentsRelation.event')"></kendo-grid-column>
					<kendo-grid-column :template="btnsTemplate" field="btnsColumn" :width="150" :title="$t('report.grid.actions')" :column-menu="false"></kendo-grid-column>
				</kendo-grid>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import store from '../../store/store';
import GridUserSettings from '../../components/grid/UserSettings';
import BtnsTemplate from '../../components/grid/StandardBtnsTemplate';
import PageTitle from '../../components/common/PageTitle';
import { mapGetters } from 'vuex';

export default {
	props: {
		// ����������, ����� ������� �� ���������� � �������� �� ������� �����������
		showHideButton: {
			default: false,
			type: Boolean
		},
		showPinButton: {
			default: true,
			type: Boolean
		},
		showNewButton: {
			default: true,
			type: Boolean
		},
		showExportTemplateButton: {
			default: false,
			type: Boolean
		},
		showImportFromExcelButton: {
			default: false,
			type: Boolean
		},
		showResizeIcon: {
			default: false,
			type: Boolean
		},
		size: {
			default: 6,
			type: Number
		},
		showBtns: {
			default: true,
			type: Boolean
		},
		showSettingsBtn: {
			default: false,
			type: Boolean
		}
	},
	components: {
		'grid-user-settings': GridUserSettings,
		PageTitle
	},
	data() {
		return {
			componentName: 'documentsRelation',
			defaultGridRows: this.$store.getters.defaultGridRows,
			settingsTooltipText: this.$t('buttons.settings.tooltipText'),
			customSettingsLoaded: false,
			searchQuery: '',
			schemaModelFields: {
				id: {
					name: 'id',
					type: 'number',
					editable: false,
					nullable: true,
					visible: true,
					titleKey: 'documentsRelation.id'
				},
				name: {
					name: 'name',
					type: 'string',
					editable: false,
					nullable: false,
					visible: true,
					titleKey: 'documentsRelation.name'
				},
				type: {
					name: 'type',
					type: 'string',
					editable: false,
					nullable: true,
					visible: true,
					titleKey: 'documentsRelation.type'
				},
				eventName: {
					name: 'type',
					type: 'string',
					editable: false,
					nullable: true,
					visible: true,
					titleKey: 'tasks.event'
				},
				createdOn: {
					name: 'type',
					type: 'date',
					editable: false,
					nullable: true,
					visible: true,
					titleKey: 'createdOn'
				},
				createdBy: {
					name: 'type',
					type: 'string',
					editable: false,
					nullable: true,
					visible: true,
					titleKey: 'createdBy'
				}
			},
			rawHtml: '',
			transportSettings: {
				read: {
					url: `${store.getters.baseUrl}/api/documentsRelation/all`,
					dataType: 'json',
					type: 'POST',
					contentType: 'application/json',
					beforeSend: this.beforeSend
				},
				parameterMap: this.parameterMap
			},
			showUserSettingsForm: false,
			loading: false
		};
	},
	methods: {
		dataSourceError(e) {
			this.$vs.notify({
				title: this.$t('notifications.error'),
				text: this.$helpers.kendoDataSourceErrorText(e),
				color: 'danger',
				time: this.$store.getters.notificationDuration
			});
		},
		goToDownload(e) {
            const downloadUri = `${this.$store.getters.baseUrl}/api/file/download?id=${e.id}&type=${e.docTypeCode}&hash=${e.hash}`;
			this.loading = true;

            this.$http.get(downloadUri, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data]);
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', (e.name)); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch(err => {
                    this.$vs.notify({
                        color: 'danger',
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(err)
                    })
                })
                .then(() => { this.loading = false; });
		},
		goToEvent(e) {
			this.$router.push('registers/events/edit/' + e.eventId);
		},
		dataBound(e) {

		},
		parameterMap: function(options, operation) {
			if (operation !== 'read' && options.models) {
				return { models: kendo.stringify(options.models) };
			} else {
				this.saveState();
				return kendo.stringify(options);
			}
		},
		saveState: function() {
			let grid = this.$refs.grid.kendoWidget();

			localStorage['audit-grid-options'] = kendo.stringify(grid.getOptions());
		},
		loadState: function() {
			let options = localStorage['kendo-grid-options'];
			let grid = this.$refs.grid.kendoWidget();

			if (options) {
				grid.setOptions(JSON.parse(options));
			}
		},
		beforeSend: function(req) {
			if (this.token) {
				req.setRequestHeader('Authorization', 'Bearer ' + this.token);
				req.setRequestHeader('Accept-Language', this.$store.getters.currentCulture);
			}
		},
		btnsTemplate: function(e) {
			return {
				template: Vue.component(BtnsTemplate.name, BtnsTemplate),
				templateArgs: {
					...e,
					parentComponent: this.$refs.grid,
					btns: [
						{
							name: 'download',
							text: this.$t('buttons.download.tooltipText'),
							class: 'btn btn-success',
							icon: 'fa fa-download',
							show: true,
							clickHandler: this.goToDownload
						},
						{
							name: 'eventLink',
							text: this.$t('buttons.eventLink.btnText'),
							class: 'btn btn-success',
							icon: 'fa fa-external-link-alt',
							show: true,
							clickHandler: this.goToEvent
						}
					]
				}
			};
		},
		clearFilters() {
			this.searchQuery = '';
			const grid = this.$refs.grid.kendoWidget();
			if (grid) {
				grid.dataSource.sort({});
				grid.dataSource.page(1);
				grid.dataSource.aggregate([]);
				grid.dataSource.filter({});
			}
		},
		massSearch() {
			if (!this.searchQuery) {
				this.$vs.notify({
                    title: this.$t('buttons.search.btnText'),
                    text: this.$t('emptySearchFilter'),
					color: 'warning',
					time: this.$store.getters.notificationDuration
				});

				return;
			}

			let grid = this.$refs.grid.kendoWidget();
			if (grid) {
				let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
				if (filter) {
					grid.dataSource.filter(filter);
				}
			}
		}
	},
	mounted: function() {
		var container = $(this.$el);
		container.find('[data-toggle="tooltip"]').tooltip({ container });
	},
	computed: {
		...mapGetters(['gridOptions']),
		token: function() {
			return store.getters.authToken;
		},
		hasReadRights() {
			return this.$store.getters.claims.documents.read;
		}
	}
};
</script>

<style scoped>
.btn {
	margin-right: 10px;
	margin-left: 5px;
}

.checkbox {
	margin-right: 5px;
}

.selectFile {
	display: none;
}

.inlineForm {
	display: inline;
}
</style>
